<template>
  <div>
    <div class="card card-custom gutter-b" style="box-shadow: none">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>

      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="8">
                  <b-row>
                    <b-col>
                      <b-form-group
                        :class="{ 'required-field': !form.nome }"
                        id="nome"
                        label-for="nome"
                        label="Descrição"
                      >
                        <b-form-input
                          v-model="$v.form.nome.$model"
                          :state="validateState('nome')"
                          autofocus
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row v-if="integracaoPosControle">
                <b-col md="6">
                  <b-form-group
                    label="Foto do grupo"
                    label-for="imagem_grupo"
                    description="JPG ou PNG, até 2 MB. A imagem enviada ao POS será convertida para 70 × 70 px."
                  >
                    <b-form-file
                      id="imagem_grupo"
                      accept="image/jpeg,image/png"
                      browse-text="Selecionar"
                      placeholder="Escolha uma imagem"
                      drop-placeholder="Solte a imagem aqui"
                      @change="selecionarImagem"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  v-if="imagemPreview"
                  class="d-flex align-items-center"
                >
                  <div class="grupo-imagem-preview">
                    <img :src="imagemPreview" alt="Foto do grupo" />
                    <b-button
                      type="button"
                      size="sm"
                      variant="outline-danger"
                      class="ml-3"
                      @click="removerImagem"
                    >
                      Remover foto
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_nova_grupo"
                class="btn btn-primary font-weight-bold"
              >
                Salvar
              </button>
              <router-link
                class="btn btn-clean font-weight-bold"
                :to="{
                  name: 'gruposLista',
                }"
              >
                Cancelar
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import GrupoData, { GrupoDataRequired } from "./GrupoData";
import { mapGetters } from "vuex";
import PosControleService from "@/modules/PosControle/services/PosControleService";

export default {
  name: "app-grupo-form",
  props: {
    url: {
      type: String,
    },
    grupo: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      imagemArquivo: null,
      imagemPreview: null,
      imagemPreviewTemporaria: null,
      integracaoPosControle: false,
    };
  },
  validations: {
    form: GrupoDataRequired,
  },
  watch: {
    grupo(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        this.imagemPreview = newValue.imagem || null;
        this.imagemArquivo = null;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
    this.carregarIntegracaoPosControle();
  },
  methods: {
    async carregarIntegracaoPosControle() {
      try {
        const response = await PosControleService.configuracao();
        const resumo = response.data.data || {};
        const integracao = resumo.integracao || {};
        this.integracaoPosControle =
          !!resumo.configurado && integracao.ativo !== false;
      } catch (error) {
        this.integracaoPosControle = false;
      }
    },
    async getDataInit() {
      this.form = await new GrupoData({});
      this.imagemPreview = null;
    },
    selecionarImagem(event) {
      const arquivo = event.target.files && event.target.files[0];
      if (!arquivo) return;

      if (arquivo.size > 2 * 1024 * 1024) {
        event.target.value = "";
        this.$toast.error("A imagem deve ter no máximo 2 MB.");
        return;
      }

      if (this.imagemPreviewTemporaria) {
        URL.revokeObjectURL(this.imagemPreviewTemporaria);
      }

      this.imagemArquivo = arquivo;
      this.imagemPreviewTemporaria = URL.createObjectURL(arquivo);
      this.imagemPreview = this.imagemPreviewTemporaria;
      this.form.remover_imagem = false;
    },
    removerImagem() {
      if (this.imagemPreviewTemporaria) {
        URL.revokeObjectURL(this.imagemPreviewTemporaria);
      }
      this.imagemArquivo = null;
      this.imagemPreviewTemporaria = null;
      this.imagemPreview = null;
      this.form.remover_imagem = true;
    },
    montarFormulario() {
      const payload = new FormData();
      if (this.form.id) payload.append("id", this.form.id);
      payload.append("nome", this.form.nome || "");
      payload.append("remover_imagem", this.form.remover_imagem ? "1" : "0");
      if (this.imagemArquivo) payload.append("imagem", this.imagemArquivo);
      return payload;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_grupo"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, this.montarFormulario());

        this.$router.push({ name: "gruposLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
  beforeDestroy() {
    if (this.imagemPreviewTemporaria) {
      URL.revokeObjectURL(this.imagemPreviewTemporaria);
    }
  },
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}

.grupo-imagem-preview {
  display: flex;
  align-items: center;
}

.grupo-imagem-preview img {
  width: 96px;
  height: 96px;
  border-radius: 8px;
  border: 1px solid #e4e6ef;
  object-fit: cover;
}
</style>
